import { Box, Skeleton } from '@mui/material';

export const MplListItemSkeleton = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				padding: '20px 8px 20px 20px',
				backgroundColor: (theme) => theme.palette.neutral.main,
				border: (theme) => `0.25px solid ${theme.palette.primary[200]}`,
				borderRadius: '8px',
				gap: '12px',
				boxShadow: '0px 8px 8px -4px #18274B14, 0px 4px 6px -4px #18274B1F',
			}}
		>
			<Skeleton variant="circular" width={24} height={24} animation="pulse" />
			<Skeleton variant="rounded" width={180} height={18} animation="pulse" />
			<Box flex={1} />
			<Skeleton variant="circular" width={24} height={24} animation="pulse" />
		</Box>
	);
};
